// Política da proposta de colaboração. O banco valida os mesmos limites.
// Enterprise continua pausado; não há venda de assentos ou links públicos.
export const INVITATION_DAYS = 7;
export const COLLABORATION_ACTIONS = ['view', 'create', 'edit', 'delete', 'execute', 'approve'];
export const COLLABORATION_MODULES = [
  { key: 'propriedades', label: 'Propriedades e Talhões' },
  { key: 'sensoriamento', label: 'Central de Operações' },
  { key: 'caderno', label: 'Caderno de Campo' },
  { key: 'irrigacao', label: 'Irrigação' },
  { key: 'produtividade', label: 'Desempenho da Propriedade' },
  { key: 'pecuaria', label: 'Pecuária' },
];
export const COLLABORATION_ROLES = {
  viewer: 'Visualizador', editor: 'Editor', administrator: 'Administrador da equipe',
  manager: 'Gerente', technician: 'Técnico', operator: 'Operador',
};
export const COLLABORATION_PLANS = Object.freeze({
  starter: { limit: 1, scope: 'account', roles: ['viewer'], team: false, label: '1 convidado visualizador na conta' },
  essential: { limit: 1, scope: 'property', roles: ['viewer', 'editor'], team: false, label: '1 convidado por propriedade' },
  professional: { limit: 2, scope: 'account', roles: ['viewer', 'editor'], team: false, label: 'Proprietário + 2 colaboradores únicos' },
  management: { limit: 9, scope: 'account', roles: Object.keys(COLLABORATION_ROLES), team: true, label: '10 pessoas, incluindo o proprietário' },
});
export const getCollaborationPolicy = plan => COLLABORATION_PLANS[plan] || {
  limit: 0, scope: 'account', roles: [], team: false, label: 'Envio de convites não disponível neste plano',
};
export const normalizeInviteEmail = email => String(email || '').trim().toLowerCase();
export function invitationState(invite, now = Date.now()) {
  return invite.status === 'pending' && new Date(invite.expires_at).getTime() <= Number(now) ? 'expired' : invite.status;
}
export function countCollaborationSeats(invites = [], { propertyId, now = Date.now() } = {}) {
  return new Set(invites.filter(invite => ['pending', 'accepted'].includes(invitationState(invite, now)))
    .filter(invite => !propertyId || invite.property_ids?.map(String).includes(String(propertyId)))
    .map(invite => invite.user_id || normalizeInviteEmail(invite.email))).size;
}
export function defaultCollaborationPermissions(role = 'viewer') {
  return Object.fromEntries(COLLABORATION_MODULES.map(({ key }) => [key,
    role === 'operator' ? (key === 'caderno' ? ['execute'] : [])
      : role === 'viewer' || role === 'technician' ? ['view']
        : key === 'sensoriamento' ? ['view'] : ['view', 'create', 'edit', 'delete', ...(key === 'caderno' ? ['execute'] : [])],
  ]));
}
export function validateCollaborationPermissions(role, permissions) {
  if (!COLLABORATION_ROLES[role] || !permissions || typeof permissions !== 'object' || Array.isArray(permissions)) return false;
  return Object.entries(permissions).every(([module, actions]) => (
    COLLABORATION_MODULES.some(item => item.key === module) && Array.isArray(actions)
    && actions.every(action => COLLABORATION_ACTIONS.includes(action)
      && (action !== 'approve' || (module === 'caderno' && ['administrator', 'manager'].includes(role)))
      && (action !== 'execute' || module === 'caderno')
      && (module !== 'sensoriamento' || action === 'view')
      && (role !== 'viewer' || action === 'view')
      && (role !== 'operator' || (module === 'caderno' && action === 'execute')))
    && (!actions.some(action => ['create', 'edit', 'delete', 'approve'].includes(action)) || actions.includes('view'))
    && (!actions.includes('approve') || actions.includes('edit'))
  ));
}
